module.exports = __webpack_public_path__ + "static/longueuil-logo-c4ae4eef656280881e374bbb5e83d93d.jpeg";